// Components
import { Flex, Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import CustomerReviewCard from '@components/v25/es/ft1/cards/customer-review-card/CustomerReviewCard'

// Assets
import Customer1 from '@images/v25/photos/customer-review.png'
import Customer2 from '@images/v25/photos/customers-4.png'
import Customer3 from '@images/v25/photos/customers-5.png'
import Customer4 from '@images/v25/photos/customers-6.png'

const userData = [
  {
    image: Customer1,
    review: {
      name: 'Paula M.',
      quote: '“¡Si hay una suscripción que recomendaría pagar, sería esta!”',
      message:
        'Mi membresía hizo todo esto posible y valió la pena de inmediato. Menos de un mes después, estaba en Italia viendo la puesta de sol en la costa.',
      memberSince: 2018,
      flag: 'cl',
      country: 'Chile'
    }
  },
  {
    image: Customer2,
    review: {
      name: 'Luis M.',
      quote: '“¡Nunca había encontrado ofertas tan buenas como estas!”',
      message:
        'Gracias a Ratepunk, mi esposo y yo pudimos visitar Brasil y disfrutar del Carnaval de Río. Ahorramos más de ',
      price: 400,
      messageEnd:
        ' en nuestros pasajes y recibimos docenas de ofertas cada semana. ¡Increíble!',
      memberSince: 2021,
      flag: 'ar',
      country: 'Argentina'
    }
  },
  {
    image: Customer3,
    review: {
      name: 'Andrea R.',
      quote:
        '“Ratepunk ha sido un salvavidas para nuestras vacaciones familiares.”',
      message:
        'Conseguimos vuelos a Cancún a mitad de precio y toda la familia disfrutó de unas vacaciones maravillosas. Recibimos tantas ofertas que siempre encontramos algo perfecto para nosotros. No podríamos estar más felices.',
      memberSince: 2020,
      flag: 'mx',
      country: 'México'
    }
  },
  {
    image: Customer4,
    review: {
      name: 'Carlos T.',
      quote:
        '“Mis amigos y yo hemos viajado por toda América Latina gracias a Ratepunk.”',
      message:
        'La cantidad de dinero que hemos ahorrado es impresionante, más de ',
      price: 500,
      messageEnd:
        ' en total. Recibimos muchas ofertas cada semana, lo que hace que sea fácil encontrar los mejores vuelos. Acabamos de regresar de una excursión en Perú, ¡fue inolvidable!',
      memberSince: 2019,
      flag: 'co',
      country: 'Colombia'
    }
  }
]

const CustomerReview = () => {
  return (
    <Section padding={[32, 0]}>
      <Text tagName="h2" variant="title-2" align="center" spacing={{ sm: 8 }}>
        Ratepunk: Una Empresa Global con Clientes Satisfechos en América Latina
      </Text>
      <Text variant="body-1" align="center" spacing={{ sm: 32 }}>
        Ofertas de vuelos en todo el mundo. Miles de clientes satisfechos en
        América Latina
      </Text>

      <Flex flexDirection="column" rowGap={{ sm: 32 }}>
        {userData.map((data, index) => (
          <CustomerReviewCard {...data} key={index} />
        ))}
      </Flex>
    </Section>
  )
}

export default CustomerReview
